import { OverviewProject, STANDARDS } from './types';

/** The lowest percentage among the standards a project was judged on; null when nothing was judged. */
export function weakestPct(p: OverviewProject): number | null {
  const all = STANDARDS.map((s) => p[s.id]?.pct).filter((v): v is number => typeof v === 'number');
  return all.length ? Math.min(...all) : null;
}

/** Projects furthest from 100% first; ties by key; a project with nothing judged goes last. */
export function furthestFirst(projects: OverviewProject[]): OverviewProject[] {
  const rank = (p: OverviewProject) => weakestPct(p) ?? Number.POSITIVE_INFINITY;
  return [...projects].sort((a, b) => rank(a) - rank(b) || a.project_key.localeCompare(b.project_key));
}
